import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { PrivacyPolicyComponent } from './privacy-policy.component';

import { ModuleRoutes } from './privacy-policy.routing';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(ModuleRoutes),
        CollapseModule.forRoot(),
        FormsModule
    ],
    declarations: [
      PrivacyPolicyComponent
    ]
})
export class PrivacyPolicyModule { }
